import CryptoJS from 'crypto-js';

// This key must match backend RATES_ENCRYPTION_KEY
const ENCRYPTION_KEY = 'fonderx-rates-2024-key';

export const decryptRates = (encryptedBase64) => {
  try {
    // Decode base64
    const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
    
    // Extract IV (first 16 bytes) and ciphertext
    const iv = CryptoJS.lib.WordArray.create(encrypted.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(encrypted.words.slice(4), encrypted.sigBytes - 16);
    
    // Generate key from secret (SHA-256)
    const key = CryptoJS.SHA256(ENCRYPTION_KEY);
    
    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    
    // Convert to string and parse JSON
    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error('Decryption error:', error);
    return [];
  }
};
